import React, { Component } from 'react';
import { formatoDecimal } from '../../../utilities/formatoNumeros'
import { normalizeEstadoPublicacion, switchCardEstado } from "../../../helper/publicacionHelper";
import { getFrontendConfig } from '../../../helper/frontendConfigHelper';
import { toast } from '../../../utilities/appToast';
import './PublicacionStyles.css';
import PropTypes from 'prop-types';

export default class PublicacionListItem extends Component {
    copyAlPortapapeles = async (e, valor, etiqueta) => {
        e.stopPropagation();
        if (valor === undefined || valor === null || valor === '') return;
        try {
            await navigator.clipboard.writeText(String(valor));
            toast.success(`${etiqueta} copiado`);
        } catch {
            toast.error('No se pudo copiar al portapapeles');
        }
    };

    render = () => {
        const {
            idPublicacion,
            titulo,
            skuSeller,
            skuMarket,
            categoria,
            precioLista,
            precioPromocional,
            estado,
            img,
            marca,
            envioGratis,
            handleEstado,
            tipoEntrega,
            fechaPublicacion,
            descripcionSeller,
            tipoPublicacion,
            stock,
            isAdminOrCategory,
            productoExceptuado,
            onOrdenes,
            hideCheckboxEstado,
            hideBtnOrdenes,
            descripcionUmbralStock
        } = this.props;

        // Aseguramos que sean strings para evitar error de React
        const marcaStr = typeof marca === 'object' && marca !== null ? (marca.descripcion ?? JSON.stringify(marca)) : marca;
        const categoriaStr = typeof categoria === 'object' && categoria !== null ? (categoria.descripcion ?? JSON.stringify(categoria)) : categoria;
        const tipoPublicacionStr = typeof tipoPublicacion === 'object' && tipoPublicacion !== null ? (tipoPublicacion.descripcion ?? JSON.stringify(tipoPublicacion)) : tipoPublicacion;
        const tipoEntregaStr = typeof tipoEntrega === 'object' && tipoEntrega !== null ? (tipoEntrega?.[0].descripcion ?? JSON.stringify(tipoEntrega)) : tipoEntrega;

        const estadoNormalizado = normalizeEstadoPublicacion(estado);
        const { text, color } = switchCardEstado(estadoNormalizado);
        const umbralNormalizado = String(descripcionUmbralStock ?? "").trim().toLowerCase();
        const stockNumerico = Number(stock);
        const stockEsNumero = Number.isFinite(stockNumerico);
        const stockConfig = getFrontendConfig()?.stockOptions ?? {};
        const umbralDesdeConfig = Number(stockConfig?.umbralStockBajo);
        const umbralStockBajo = Number.isFinite(umbralDesdeConfig) && umbralDesdeConfig >= 0
            ? umbralDesdeConfig
            : 3;

        let stockTier = "alto";
        if ((stockEsNumero && stockNumerico <= 0) || umbralNormalizado === "sin stock") {
            stockTier = "sin";
        } else if (umbralNormalizado === "stock bajo" || (stockEsNumero && stockNumerico <= umbralStockBajo)) {
            stockTier = "bajo";
        }

        let labelEstado =
            <div>
                <span className={`label label-item label-${color}`}>{text}</span>
            </div>
            ;

        const handleEstadoClick = (e) => {
            e.stopPropagation();
            handleEstado(e, { idPublicacion: idPublicacion, estado: estado, skuSeller: skuSeller, stock: stock });
        };

        let checkboxEstado =
            <span
                style={{ border: "none", background: "none", cursor: "pointer", display: "inline-block" }}
                className="custom-control form-switch"
                role="button"
                tabIndex={0}
                onClick={handleEstadoClick}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleEstadoClick(e); } }}
            >
                <input
                    id={idPublicacion}
                    type="checkbox"
                    className="form-check-input"
                    defaultChecked={estadoNormalizado === "activo"}
                    readOnly
                />
                <span htmlFor={idPublicacion} className="custom-control-label text-capitalize d-block">
                    <span className={`label label-item label-${color}`}>{text}</span>
                </span>
            </span>
            ;


        const handleOrdenesClick = (e) => {
            e.stopPropagation();
            onOrdenes(e, this.props.skuMarket);
        };

        let btnOrdenes =
            <div className='mt-2 font-14 applyFont'>
                <span
                    style={{ border: "none", background: "none", cursor: "pointer", display: "inline-block" }}
                    role="button"
                    tabIndex={0}
                    onClick={handleOrdenesClick}
                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleOrdenesClick(e); } }}
                    className="sl-icon-basket text-decoration-none fs-6 color-rojo-megatone me-1"
                >
                Ordenes
                </span>
            </div>

        const fechaCorta = fechaPublicacion ? fechaPublicacion.substr(0, 10) : "";
        let stockClass = "stock-alto";
        let stockText = "Stock alto";
        if ((stockEsNumero && stockNumerico <= 0) || umbralNormalizado === "sin stock") {
            stockClass = "sin-stock";
            stockText = "Sin stock";
        } else if (umbralNormalizado === "stock bajo" || (stockEsNumero && stockNumerico <= umbralStockBajo)) {
            stockClass = "stock-bajo";
            stockText = "Stock bajo";
        }

        return (
            <div className={`list-group-item publicacion-card publicacion-card--stock-${stockTier}`}>
                <div className="pub-row">
                    <div className="pub-row__media">
                        {img ? (
                            <img className="pub-row__thumb" alt={titulo ? titulo.substring(0, 10) : "Producto"} src={img} loading="lazy" decoding="async" />
                        ) : (
                            <div className="pub-row__thumb pub-row__thumb--empty" aria-label="Sin imagen" />
                        )}
                        {this.props.onReprocesarImagen && (
                            <button
                                type="button"
                                className="pub-row__reprocess"
                                disabled={this.props.reprocesandoImagenes}
                                onClick={e => { e.stopPropagation(); this.props.onReprocesarImagen(); }}
                            >
                                <i className="fa fa-refresh" aria-hidden="true" />
                                Reprocesar
                            </button>
                        )}
                    </div>

                    <div className="pub-row__main">
                        <h6 className="pub-row__title">
                            <span
                                className="orden-copy-id"
                                role="button"
                                tabIndex={0}
                                title="Clic para copiar nombre del producto"
                                onClick={(e) => this.copyAlPortapapeles(e, titulo, 'Nombre del producto')}
                                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.copyAlPortapapeles(e, titulo, 'Nombre del producto'); } }}
                            >
                                {titulo}
                            </span>
                        </h6>
                        <div className="pub-row__chips">
                            {marcaStr ? <span>{marcaStr}</span> : null}
                            {categoriaStr ? <span>{categoriaStr}</span> : null}
                            {tipoPublicacionStr ? <span>{tipoPublicacionStr}</span> : null}
                        </div>
                        <p className="pub-row__skus">
                            <span>SKU seller </span>
                            <span
                                className="orden-copy-id"
                                role="button"
                                tabIndex={0}
                                title="Clic para copiar SKU seller"
                                onClick={(e) => this.copyAlPortapapeles(e, skuSeller, 'SKU seller')}
                                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.copyAlPortapapeles(e, skuSeller, 'SKU seller'); } }}
                            >
                                {skuSeller}
                            </span>
                            <span> · SKU market </span>
                            <span
                                className="orden-copy-id"
                                role="button"
                                tabIndex={0}
                                title="Clic para copiar SKU market"
                                onClick={(e) => this.copyAlPortapapeles(e, skuMarket, 'SKU market')}
                                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.copyAlPortapapeles(e, skuMarket, 'SKU market'); } }}
                            >
                                {skuMarket}
                            </span>
                        </p>
                        <span className={`stock-indicator ${stockClass}`}>
                            {stockText} · {stock}
                        </span>
                    </div>

                    <div className="pub-row__identity">
                        <span className="pub-row__seller">{descripcionSeller}</span>
                        {fechaCorta ? <span className="pub-row__date">{fechaCorta}</span> : null}
                        <span
                            className="pub-row__id orden-copy-id"
                            role="button"
                            tabIndex={0}
                            title="Clic para copiar ID publicación"
                            onClick={(e) => this.copyAlPortapapeles(e, idPublicacion, 'ID publicación')}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.copyAlPortapapeles(e, idPublicacion, 'ID publicación'); } }}
                        >
                            #{idPublicacion}
                        </span>
                    </div>

                    <div className="pub-row__side">
                        <div className="pub-row__price">
                            <span
                                className="orden-copy-id"
                                role="button"
                                tabIndex={0}
                                title="Clic para copiar precio publicado"
                                onClick={(e) => this.copyAlPortapapeles(e, (precioPromocional || precioLista), 'Precio')}
                                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.copyAlPortapapeles(e, (precioPromocional || precioLista), 'Precio'); } }}
                            >
                                $ {(precioPromocional) ? formatoDecimal(precioPromocional) : formatoDecimal(precioLista)}
                            </span>
                            <small>Precio publicado</small>
                        </div>
                        {(tipoEntregaStr || envioGratis) && (
                            <p className="pub-row__delivery">
                                {tipoEntregaStr ?? ""}
                                {envioGratis ? " · Envío gratis" : ""}
                            </p>
                        )}
                        {hideCheckboxEstado && labelEstado}
                        {!hideCheckboxEstado && (isAdminOrCategory ? checkboxEstado : labelEstado)}
                        {isAdminOrCategory && productoExceptuado &&
                            <small className="label label-item label-red mt-1 p-1">
                                Producto exceptuado
                            </small>
                        }
                        {!hideBtnOrdenes && btnOrdenes}
                    </div>
                </div>
            </div>
        );
    }
}
PublicacionListItem.propTypes = {
    onReprocesarImagen: PropTypes.func,
    reprocesandoImagenes: PropTypes.bool,
    idPublicacion: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    titulo: PropTypes.string,
    skuSeller: PropTypes.number,
    skuMarket: PropTypes.number,
    categoria: PropTypes.shape({
        descripcion: PropTypes.string,
    }),
    precioLista: PropTypes.string,
    precioPromocional: PropTypes.string,
    estado: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    img: PropTypes.string,
    marca: PropTypes.shape({
        descripcion: PropTypes.string,
    }),
    envioGratis: PropTypes.bool,
    handleEstado: PropTypes.func,
    tipoEntrega: PropTypes.shape({
        descripcion: PropTypes.string,
    }),
    fechaPublicacion: PropTypes.string,
    descripcionSeller: PropTypes.string,
    tipoPublicacion: PropTypes.shape({
        descripcion: PropTypes.string,
    }),
    stock: PropTypes.number,
    isAdminOrCategory: PropTypes.bool,
    productoExceptuado: PropTypes.bool,
    onOrdenes: PropTypes.func,
    hideCheckboxEstado: PropTypes.bool,
    hideBtnOrdenes: PropTypes.bool,
    descripcionUmbralStock: PropTypes.string,
}
